import { createReducer, on } from "@ngrx/store";
import {addOperacionesTipoIva, addOperacionesTipoIvaError,updateOperacionesTipoIva, clearOperacionesTipoIva, deleteOperacionTipoIva} from "../actions/operacionTipoIva.actions";
import { initialOperacionesTipoIvaState } from "../../core/interfaces/models/operacionTipoIva.interface";

export const operacionTipoIvaReducer = createReducer(
  initialOperacionesTipoIvaState,
  on(addOperacionesTipoIva, (_, { operacionesTipoIvaState }) => (
    operacionesTipoIvaState
  )),
  on(addOperacionesTipoIvaError, (state,debugMessage:any) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateOperacionesTipoIva,(state, { operacionTipoIva }) => ({
    ...state,
    operacionesTipoIva: state.operacionesTipoIva.map(u =>
      u.id === operacionTipoIva.id ? operacionTipoIva : u
    )
  })),
  on(deleteOperacionTipoIva, (state, { id }) => ({
    ...state,
    operacionesTipoIva: state.operacionesTipoIva.filter(operacionTipoIva => operacionTipoIva.id !== id)
  })),

  on(clearOperacionesTipoIva, () => initialOperacionesTipoIvaState),
);